const SectionHeading = ({ tag = '', tagBg = '#fceee0', tagColor = '#b75b0b', title = '', highlight = '', subtitle = '', align = 'center', }) => {
    const alignment = align === 'left' ? 'text-left items-start' : 'text-center items-center';

    return (
        <div className={`flex flex-col gap-2 mb-6 ${alignment}`}>
            {tag && (
                <div className={`inline-block px-4 pt-1.5 pb-1 rounded-full text-xs font-semibold tracking-widest uppercase bg-[${tagBg}] text-[${tagColor}]`}>
                    {tag}
                </div>
            )}

            <h2 className="text-[32px] max-md:text-[24px] font-bold tracking-tight leading-snug">
                {title} {highlight && <span className="text-primary">{highlight}</span>}
            </h2>

            {subtitle && (
                <p className="text-foreground text-sm sm:text-base font-medium max-w-xl">
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default SectionHeading;